import * as eff from 'redux-saga/effects';
import * as XLSX from 'xlsx';

import {
  uiActions,
  actionTypes,
} from 'web-actions';

import createXMLHttpRequestChannel from './createXMLHttpRequestChannel';

function* downloadFileSaga({ key, url }): Generator<eff.Effect, void, any> {
  const channel = yield eff.call(
    createXMLHttpRequestChannel,
    {
      url,
      method: 'GET',
      responseType: 'arraybuffer',
    },
  );

  try {
    while (true) {
      const {
        err,
        result,
        success,
        progress = 0,
      } = yield eff.take(channel);

      if (err) {
        yield eff.put(
          uiActions.setFileDownloadState({
            error: true,
          }, key),
        );
        return err;
      }

      if (success) {
        const workbook = XLSX.read(new Uint8Array(result), { type: 'array' });

        yield eff.put(
          uiActions.setFileDownloadState({
            workbook,
            success: true,
          }, key),
        );
        return result;
      }
      yield eff.put(
        uiActions.setFileDownloadState({
          progress,
        }, key),
      );
    }
  } finally {
    if (yield eff.cancelled()) {
      channel.close();
    }
  }
}

export default function* downloadFlow(): Generator<eff.Effect, void, any> {
  function* downloadDocument({ documentId, documentUrl }): Generator<eff.Effect, void, any> {
    try {
      yield eff.call(
        downloadFileSaga,
        {
          key: documentId,
          url: documentUrl,
        },
      );
    } catch (e) {
      console.log(e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_DOWNLOAD_DOCUMENT, downloadDocument);
}
